export const dashboardRoutes = {
    label: 'Dashboard',
    labelDisable: true,
    children: [
        {
            name: 'Dashboard',
            active: true,
            icon: 'chart-pie',
            children: [
                {
                    name: 'Sales Indicators',
                    to: '/',
                    exact: true,
                    active: true
                },
                {
                    name: 'Akasia POS',
                    to: '/dashboard/akasia-pos',
                    active: true
                },
                {
                    name: 'Support Engine',
                    to: '/support-engine',
                    target: '_blank',
                    excludedUserTypes: [2, 6],
                    active: true
                },
                {
                    name: 'Support Desk',
                    to: '/dashboard/support-desk',
                    active: true
                },
                {
                    name: 'Reporte Ventas',
                    active: true,
                    to: '/dashboard/reporte-ventas'
                }

            ]
        }
    ]
};

var leads = {
    name: 'Leads',
    icon: 'user',
    active: true,
    children: [
        {
            name: 'Catálogo leads',
            to: '/leads/catalogo',
            active: true
        },
        {
            name: 'Reporte Seguimiento',
            active: true,
            to: '/dashboard/reporte-seguimiento-leads'

        }
    ]

}


var marketing = {
    name: 'Marketing',
    icon: 'chart-line',
    active: true,
    children: [

        {
            name: 'Dashboard',
            to: '/marketing/dashboard',
            active: true
        },
        {
            name: 'Calendario editorial',
            to: '/marketing/calendario-editorial',
            active: true
        }
    ]
}

var contabilidad = {
    name: 'Contabilidad',
    icon: 'book',
    active: true,
    children: [
        {
            name: 'Centro de XML',
            active: true,
            children: [
                {
                    name: 'Descarga Masiva',
                    to: '/contabilidad/centro-xml/descarga-masiva/cargar-xml',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Fact. Emitidas',
                    to: '/contabilidad/centro-xml/facturas-emitidas',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Fact. Recibidas',
                    to: '/contabilidad/centro-xml/facturas-recibidas',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Pagos Emitidos',
                    to: '/contabilidad/centro-xml/pagos-emitidos',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Pagos Recibidos',
                    to: '/contabilidad/centro-xml/pagos-recibidos',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Nueva Factura',
                    to: '/contabilidad/facturacion/formulario-factura',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Complemento de Pago',
                    to: '/contabilidad/facturacion/formulario-complemento-pago',
                    active: true,
                    icon: 'check'
                }

            ]
        },
        {
            name: 'Nómina',
            active: true,
            children: [
                {
                    name: 'Catálogo de Empleados',
                    to: '/contabilidad/nomina/catalogo-empleados',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Cálculo de Periodos',
                    to: '/contabilidad/nomina/calculo-periodos',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Timbrado de CFDIs de Nómina',
                    to: '/contabilidad/nomina/timbrado',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Conciliación IMSS',
                    to: '/contabilidad/nomina/conciliacion-imss',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Impuestos Estatales y Retenciones',
                    to: '/contabilidad/nomina/impuestos-estatales-retenciones',
                    active: true,
                    icon: 'cancel'
                }

            ]
        },
        {
            name: 'Contabilidad y libros',
            active: true,
            children: [
                {
                    name: 'Catálogo de Cuentas',
                    to: '/contabilidad/conta-libros/catalogo-cuentas',
                    active: true,
                    icon: 'check',
                    children: [
                        {
                            name: 'Administrar cuentas',
                            to: '/contabilidad/conta-libros/catalogo-cuentas/administrar',
                            active: true,
                            icon: 'check'
                        }
                    ]
                },
                {
                    name: 'Pólizas Dinámicas',
                    to: '/contabilidad/conta-libros/polizas-dinamicas',
                    active: false,
                    icon: 'cancel'
                },
                {
                    name: 'Diario de Pólizas',
                    to: '/contabilidad/conta-libros/diario-polizas',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Auxiliares de Cuentas',
                    to: '/contabilidad/conta-libros/auxiliar-cuenta',
                    active: true,
                    icon: 'cancel'
                }
                ,
                {
                    name: 'Libro mayor',
                    to: '/contabilidad/conta-libros/libro-mayor',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Cierre de Ejercicio',
                    to: '/contabilidad/conta-libros/cierre-ejercicio',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Control de Periodos',
                    to: '/contabilidad/conta-libros/control-periodos',
                    active: true,
                    icon: 'cancel'
                }
            ]
        },
        {
            name: 'Bancos y Flujo de Efectivo',
            active: true,
            children: [
                {
                    name: 'Cuentas Bancarias',
                    to: '/contabilidad/bancos/cuentas-bancarias',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Edo. de Cuenta',
                    to: '/contabilidad/bancos/estados-cuenta',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Conciliación bancaria',
                    to: '/contabilidad/bancos/conciliacion',
                    active: true,
                    icon: 'check'
                },

                {
                    name: 'Flujo de Efectivo Operativo',
                    to: '/contabilidad/bancos/flujo-efectivo',
                    active: true,
                    icon: 'cancel'
                }

            ]
        },
        {
            name: 'Impuestos y Fiscal',
            active: true,
            children: [
                {
                    name: 'Cálculo de Impuestos',
                    to: '/contabilidad/impuestos/calculo',
                    active: true,
                    icon: 'check'
                },
                {
                    name: 'Genera DIOT',
                    to: '/contabilidad/impuestos/descarga-diot',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'CSF',
                    to: '/contabilidad/impuestos/descarga-diot',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Auditoría SAT',
                    to: '/contabilidad/impuestos/auditoria-sat',
                    active: true,
                    icon: 'cancel'
                }

            ]
        },
        {
            name: 'Reportes Financieros',
            active: true,
            children: [
                {
                    name: 'Balance General',
                    to: '/contabilidad/bancos/',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Estado de Resultados',
                    to: '/contabilidad/impuestos/estado-resultados',
                    active: true,
                    icon: 'cancel'
                },
                {
                    name: 'Balanza de Comprobación',
                    to: '/contabilidad/impuestos/balanza-comprobacion',
                    active: true,
                    icon: 'cancel'
                }

            ]
        },
        {
            name: 'Configuración',
            active: true,
            children: [
                {
                    name: 'Datos Fiscales y Certificados',
                    to: '/contabilidad/facturacion/ajustes',
                    active: true,
                    icon: 'check'
                }
            ]
        }

    ]
};

var clientes = {
    name: 'Clientes',
    icon: 'shopping-cart',
    active: true,
    children: [
        {
            name: 'Catálogo clientes',
            to: '/clientes/catalogo',
            active: true
        },
        {
            name: 'Nuevo cliente',
            to: '/clientes/nuevo',
            active: true
        },
        {
            name: 'Lista de \u00F3rdenes',
            to: '/ordenes',
            active: true
        },
        {
            name: 'Distribuidores',
            to: '/clientes/distribuidores',
            active: true
        },
        {
            name: 'TAECEL',
            to: '/servicios/registro-taecel',
            active: true
        }
    ]
}


var productos =
{
    name: 'Productos',
    icon: 'archive',
    active: true,
    children: [
        {
            name: 'Catálogo Productos',
            to: '/productos/catalogo',
            active: true
        },
        {
            name: 'Nuevo Producto',
            to: '/productos/nuevo',
            active: true
        },
        {
            name: 'Módulos AKS-POS',
            to: '/modulos/catalogo',
            active: true
        }
    ]
}



var licencias = {
    name: 'Licencias',
    icon: 'file',
    active: true,
    children: [
        {
            name: 'Cat\u00E1logo licencias',
            to: '/licencias/',
            active: true
        },
        {
            name: 'Nueva Licencia',
            to: '/licencias/nueva',
            active: true
        },
        {
            name: 'Usuarios Nube Akasia',
            to: '/servicios/usuarios-nube-akasia',
            active: true
        }
        ,
        {
            name: 'Logs',
            to: '/logservicios/logs',
            active: true
        },
        {
            name: 'Licencias Vencidas',
            to: '/licencias/vencidas-borrado',
            active: true
        }
    ]
}

var posFacturacion = {
    name: 'POS Fact.',
    icon: 'ticket-alt',
    active: true,
    children: [
        {
            name: 'POS Fact. Guatemala',
            to: '/servicios/facturacion-guatemala',
            active: true
        }
        ,
        {
            name: 'POS Fact. Ecuador',
            to: '/servicios/facturacion-ecuador',
            active: true
        }
        ,
        {
            name: 'POS Fact. Panam\u00e1',
            to: '/servicios/facturacion-panama',
            active: true
        }
        ,
        {
            name: 'POS Fact. Per\u00fa',
            to: '/servicios/facturacion-peru',
            active: true
        }
        ,
        {
            name: 'POS Fact. Bolivia',
            to: '/servicios/facturacion-bolivia',
            active: true
        }
        ,
        {
            name: 'POS Fact. El Salvador',
            to: '/servicios/facturacion-elsalvador',
            active: true
        }
        ,
        {
            name: 'POS Fact. Costa Rica',
            to: '/servicios/facturacion-costarica',
            active: true
        }
        ,
        {
            name: 'POS Fact. México',
            to: '/servicios/facturacion-mexico',
            active: true
        },
        {
            name: 'POS Fact. R. D.',
            to: '/servicios/facturacion-republica-dominicana',
            active: true
        }
    ]
}

var administracion = {
    name: 'Administración',
    active: true,
    icon: 'book',
    children: [
        {
            name: 'Pagos',
            to: '/administracion/pagos',
            active: true
        },
        {
            name: 'Cuentas STR-PPL',
            to: '/administracion/cuentas-stripe-paypal',
            active: true
        },
        {
            name: 'Activo Fijo',
            to: '/administracion/activo-fijo',
            active: true
        },
        {
            name: 'Usuarios AP',
            to: '/administracion/usuarios-sistema/lista',
            active: true
        },
        {
            name: 'Vacaciones',
            to: '/administracion/usuarios-sistema/vacaciones',
            active: true
        }
        ,
        {
            name: 'Gastos / Egresos',
            to: '/administracion/gastos',
            active: true
        }

    ]
}


export var appRoutes = {
    label: 'app',
    children: [
        leads,
        marketing,
        clientes,
        productos,
        licencias,
        posFacturacion,
        administracion
    ]
};




export const pagesRoutes = {
    label: 'M\u00f3dulos',
    children: [
        contabilidad

    ]
};


export default [
    dashboardRoutes,
    appRoutes,
    pagesRoutes
];

